// fileStore.ts
import { writable } from 'svelte/store';

interface BoatFiles {
	photosFiles: File[];
	insuranceFile: FileList | null;
	itbFile: FileList | null;
	navigationPermisoFile: FileList | null;
}

const initialState: BoatFiles = {
	photosFiles: [],
	insuranceFile: null,
	itbFile: null,
	navigationPermisoFile: null
};

export const uploadBoatFilesStore = writable(initialState);

export function ClearBoatFiles() {
	const initialState: BoatFiles = {
		photosFiles: [],
		insuranceFile: null,
		itbFile: null,
		navigationPermisoFile: null
	};

	uploadBoatFilesStore.set(initialState);
}
